import React from 'react';
import './TemplateTable.css';

const TemplateTable = ({ templates, onView, onEdit, onDelete }) => {
  if (!templates || templates.length === 0) {
    return (
      <div className="template-table-container">
        <div className="tableWrapper mt-3">
          <div className="empty-state">
            No templates found. Create your first template to get started.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-centered table-hover mb-0">
        <thead>
          <tr>
            <th>Name</th>
            <th>Platform</th>
            <th>Content</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {templates?.map((template) => (
            <tr key={template._id}>
              <td>{template.name}</td>
              <td>{template.templatePlatform}</td>
              <td>{template.value ? template.value.substring(0, 50) + (template.value.length > 50 ? '...' : '') : 'No message'}</td>
              <td>
                <span
                  className={`badge ${
                    template.status === "active"
                      ? "bg-success"
                      : "bg-danger"
                  }`}
                >
                  {template.status}
                </span>
              </td>
              <td>
                <button
                  className="bouncy-button white small me-1"
                  onClick={() => onView(template)}
                >
                  <i className="mdi mdi-eye"></i>
                </button>
                <button
                  className="bouncy-button white small me-1"
                  onClick={() => onEdit(template)}
                >
                  <i className="mdi mdi-pencil"></i>
                </button>
                <button
                  className="bouncy-button negative small me-1"
                  onClick={() => onDelete(template)}
                >
                  <i className="mdi mdi-delete"></i>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TemplateTable; 